import styled from 'styled-components';
import { media, Row, hideScrollbar } from '@simplywallst/ui-core';

interface WrapperProps {
  hidden?: boolean;
  height?: number | string;
  heightMdDown?: number | string;
  heightSmDown?: number | string;
  minHeightMdDown?: number | string;
  minHeightSmDown?: number | string;
  scrollOnOverflow?: boolean;
  showDefaultMode?: boolean;
  hideTableScrollbars?: boolean;
}

export const Space = styled.div`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
`;

export const Wrapper = styled('div')<WrapperProps>`
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
  overflow-y: ${({ scrollOnOverflow }) => (scrollOnOverflow ? 'auto' : 'none')};
  ${({ height }) =>
    typeof height === 'number'
      ? `min-height: ${height}px;`
      : height && `min-height: ${height};`}
  ${media.mdDown`
  ${({ heightMdDown }) =>
    typeof heightMdDown === 'number'
      ? `height: ${heightMdDown}px;`
      : heightMdDown && `height: ${heightMdDown};`}
	`}
  ${media.smDown`
  ${({ heightSmDown }) =>
    typeof heightSmDown === 'number'
      ? `height: ${heightSmDown}px;`
      : heightSmDown && `height: ${heightSmDown};`}
	`}
  ${media.mdDown`
  ${({ minHeightMdDown }) =>
    typeof minHeightMdDown === 'number'
      ? `min-height: ${minHeightMdDown}px;`
      : minHeightMdDown && `min-height: ${minHeightMdDown};`}
	`}
  ${media.smDown`
  ${({ minHeightSmDown }) =>
    typeof minHeightSmDown === 'number'
      ? `min-height: ${minHeightSmDown}px;`
      : minHeightSmDown && `min-height: ${minHeightSmDown};`}
	`}
  ${({ showDefaultMode }) => showDefaultMode && 'opacity: 0.2'};
  ${({ hideTableScrollbars }) => hideTableScrollbars && hideScrollbar}
`;

export const Container = styled('div')`
  position: relative;
`;
export const DefaultOverlay = styled(Row)`
  z-index: 1;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  text-align: center;
  ${({ theme }) => theme.typography.smallStrong}
`;

export const ActionsPlaceHolder = styled('div')`
  margin-top: ${({ theme }) => theme.x3spacePx}px;
  height: ${({ theme }) => theme.x4spacePx}px;
  width: ${({ theme }) => theme.x4spacePx}px;
`;
